import { render, staticRenderFns } from "./fieldlist.vue?vue&type=template&id=58a07141&scoped=true&"
import script from "./fieldlist.vue?vue&type=script&lang=js&"
export * from "./fieldlist.vue?vue&type=script&lang=js&"
import style0 from "./fieldlist.vue?vue&type=style&index=0&id=58a07141&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a07141",
  null
  
)

export default component.exports